// extracted by mini-css-extract-plugin
export var aiStarSpin = "_ri-1";
export var spinner = "_ri-0";